import ServiceBusController from "servicestack/service-bus.controller";
import labels from "emun.order/_labels";
import sendEmailPrompt from "servicestack/email/send-email-prompt";

export default class ApproveCartController extends ServiceBusController {
  $onInit() {
    const $ctrl = this;
    $ctrl.labels = labels;
    $ctrl.loading = new Date();
    $ctrl.$cart
      .load($ctrl.cartId, $ctrl.token)
      .then(() => {
        if ($ctrl.autoApprove) {
          $ctrl.submit();
        }
      })
      .finally(() => {
        $ctrl.loading = false;
        console.debug("this,", $ctrl, $ctrl.$cart);
      });
  }

  itemNeedsApproval(i) {
    return i.product && i.product.meta && i.product.meta.MaxNumLines > 0;
  }

  contactRep() {
    const $ctrl = this;
    const { email: from, companyName } = $ctrl.$cart.purchaser;
    const { email: repEmail, fullName } = $ctrl.$cart.repBy;
    sendEmailPrompt({
      hideRecipientButtons: true,
      showReplyTo: true,
      title: `Have questions about approval?`,
      model: {
        to: repEmail || "customercare@demdaco.com",
        from,
        subject: `Approval Questions #${$ctrl.cartId}`,
        message: `Hi ${fullName}, what can you tell me about the approval process?
        
Thanks,
${companyName}`,
      },
    });
  }

  submit() {
    const $ctrl = this;
    // https://emun1.monday.com/boards/333027351/views/4635648/pulses/1409081602
    // return $ctrl.$modals
    //   .confirm(`Please ensure all text is accurate`, "Approve Order?")
    //   .result.then(() => {
    $ctrl.submitting = new Date();
    $ctrl.bus
      .send(`ApproveCustomizedText.json`, {
        cartId: $ctrl.cartId,
        token: $ctrl.token,
      })
      .then(
        (res) => {
          $ctrl.done = res.data;
          $ctrl.submitting = false;
          $ctrl.submitted = new Date();
        },
        (res) => {
          $ctrl.failed = res.data;
          $ctrl.submitting = false;
        }
      )
      .finally(() => {
        $ctrl.submitting = false;
      });
    // });
  }
}
